import { render } from "./SupplierBankAccountEditMenu.vue?vue&type=template&id=6673f606&scoped=true"
import script from "./SupplierBankAccountEditMenu.vue?vue&type=script&lang=js"
export * from "./SupplierBankAccountEditMenu.vue?vue&type=script&lang=js"

import "./SupplierBankAccountEditMenu.vue?vue&type=style&index=0&id=6673f606&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6673f606"]])

export default __exports__